////
/// ============================================================================
/// COMPONENT / Lightbox
/// ============================================================================
///
/// @group components
////

import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
//import lgVideo from 'lightgallery/plugins/video';
import lgZoom from 'lightgallery/plugins/zoom';

let lightboxProduct = function () {
    document.querySelectorAll('.woocommerce-product-gallery').forEach(function (gallery) {
        gallery.style.opacity = 1;

        lightGallery(gallery.querySelector('.woocommerce-product-gallery__wrapper'), {
            plugins: [lgZoom, lgThumbnail],
            selector: 'div a',
            speed: 500,
            download: false,
        });
    });
};

export {lightboxProduct};
